import React from 'react'
import { styled } from '@mui/system'
import { BORDER_RADIUSES } from '../consts'

const SearchResultImage = styled('img')({
  width: 60,
  height: 40,
  borderRadius: BORDER_RADIUSES.medium,
})

const PlayerSearchResultImage = styled('img')({
  width: 40,
  height: 40,
  borderRadius: BORDER_RADIUSES.medium,
})

export function PLLContentSearchResult({
  hit,
  components,
}: {
  hit: any
  components: any
}) {
  return (
    <a href={hit.hyperlink} className="aa-ItemLink">
      <div className="aa-ItemContent">
        {hit?.image && (
          <SearchResultImage src={hit.image} loading="lazy" alt={`Search for ${hit?.title}`} />
        )}
        <div className="aa-ItemTitle">
          <components.Highlight hit={hit} attribute="title" />
        </div>
      </div>
    </a>
  )
}

export function PLLSearchResult({ hit, components }: { hit: any; components: any }) {
  return (
    <a href={hit.hyperlink} className="aa-ItemLink">
      <div className="aa-ItemContent">
        {hit?.image && (
          <PlayerSearchResultImage src={hit.image} loading="lazy" alt={`Search for ${hit?.title}`} />
        )}
        <div className="aa-ItemTitle">
          <components.Highlight hit={hit} attribute="title" />
        </div>
      </div>
    </a>
  )
}
